/** Original algorithmic score, authored for this project. No sampled/third-party recording.
 * MIDI notes, pentatonic motifs, shared tonal center. QA inspects plans without rendering audio. */
export type Soundscape =
  "garden" | "grove" | "quarry" | "explore" | "battle" | "boss";
export const SCORES: Record<
  Soundscape,
  { bpm: number; notes: number[]; bass: number; ambience: number }
> = {
  garden: {
    bpm: 72,
    notes: [72, 76, 79, 0, 76, 74, 72, 0, 67, 72, 74, 76, 74, 0, 72, 0],
    bass: 48,
    ambience: 146,
  },
  grove: {
    bpm: 66,
    notes: [67, 72, 74, 0, 79, 76, 74, 0, 72, 67, 64, 0, 67, 72, 0, 0],
    bass: 43,
    ambience: 130,
  },
  quarry: {
    bpm: 62,
    notes: [76, 0, 79, 83, 0, 79, 76, 0, 74, 0, 71, 0, 76, 0, 0, 0],
    bass: 40,
    ambience: 164,
  },
  explore: {
    bpm: 80,
    notes: [64, 67, 0, 71, 74, 0, 72, 67, 64, 0, 67, 71, 0, 0, 67, 0],
    bass: 40,
    ambience: 123,
  },
  battle: {
    bpm: 112,
    notes: [64, 67, 71, 67, 64, 72, 71, 67, 62, 67, 71, 74, 72, 71, 67, 64],
    bass: 40,
    ambience: 98,
  },
  boss: {
    bpm: 124,
    notes: [52, 64, 67, 71, 52, 64, 72, 71, 50, 62, 67, 74, 50, 62, 71, 67],
    bass: 28,
    ambience: 82,
  },
};
export const frequency = (midi: number) => 440 * Math.pow(2, (midi - 69) / 12);
export function scoreBeat(scene: Soundscape, index: number) {
  const s = SCORES[scene];
  return {
    note: s.notes[index % s.notes.length],
    bass: index % 4 === 0 ? s.bass : 0,
    drum: (scene === "battle" || scene === "boss") && index % 2 === 0,
    duration: 60 / s.bpm / 2,
  };
}
